import { useMutation } from '@apollo/client'
import { EditEventAttendee, EditEventAttendeeVariables } from '../../types'
import { EDIT_EVENT_ATTENDEE } from './operations'

export const useEditEventAttendee = () =>
  useMutation<EditEventAttendee, EditEventAttendeeVariables>(EDIT_EVENT_ATTENDEE)
